import React, { useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { LocalForm } from 'react-redux-form'
import { Grid } from '@mui/material'
import { Col, FormGroup } from 'reactstrap'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { updatePrivacy, getAdminPageInfo } from '../../actions/settings';

const PrivacyPolicy = () => {
    const loaders = useSelector((state) => state.loader)
    const adminPageInfo = useSelector((state) => state.adminPageInfo.adminPageInfo);

    const [englishContent, setEnglishContent] = useState('');
    const [spanishContent, setSpanishContent] = useState('');
    const [armenianContent, setArmenianContent] = useState('');

    const [errors, setErrors] = useState({
        english: '',
        spanish: '',
        armenian: '',
    });

    const dispatch = useDispatch();

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean']
        ],
        clipboard: {
            matchVisual: false,
        }
    };
    const formats = [
        'header', 'font', 'size',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link'
    ];

    const handleEnglishChange = (content) => {
        setEnglishContent(content);
        setErrors({ ...errors, english: '' });
    };

    const handleSpanishChange = (content) => {
        setSpanishContent(content);
        setErrors({ ...errors, spanish: '' });
    };

    const handleArmenianChange = (content) => {
        setArmenianContent(content);
        setErrors({ ...errors, armenian: '' });
    };

    const validateContent = () => {
        const textContent = (html) => html.replace(/<\/?[^>]+(>|$)/g, "").trim();

        const newErrors = {
            english: textContent(englishContent) === '' ? 'This field is required' : '',
            spanish: textContent(spanishContent) === '' ? 'This field is required' : '',
            armenian: textContent(armenianContent) === '' ? 'This field is required' : ''
        };

        setErrors(newErrors);

        return !Object.values(newErrors).some(error => error !== '');
    };

    const handleAddSubmit = () => {
        if (!validateContent()) {
            return;
        }

        const data = {
            privacy_policy_en: englishContent,
            privacy_policy_am: armenianContent,
            privacy_policy_es_mx: spanishContent
        }

        dispatch(
            updatePrivacy(data, (res) => {
                if (res) {
                    dispatch(getAdminPageInfo({ page: 'privacy' }, (res) => { }))
                }
            }),
        )
    }

    useEffect(() => {
        dispatch(getAdminPageInfo({ page: 'privacy' }, (res) => { }))
    }, [])

    useEffect(() => {
        if (adminPageInfo) {
            setEnglishContent(adminPageInfo.privacy_policy_en);
            setSpanishContent(adminPageInfo.privacy_policy_es_mx);
            setArmenianContent(adminPageInfo.privacy_policy_am);
        }
    }, [adminPageInfo]);

    return (
        <div>
            <Loader loading={loaders.isFetching} />
            <div style={{ display: 'flex' }}>
                <div>
                    <p className="headinguser">Privacy Policy</p>
                    <p className="subheadinggraph">Manage Privacy Policy</p>
                </div>
            </div>

            <div>

                <LocalForm model="user" onSubmit={(values) => handleAddSubmit(values)}>
                    <div className="passTab1">
                        <div className="passDiv">
                            <div class="mb-3">
                                <div
                                    style={{

                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        position: 'relative',
                                    }}
                                >

                                    <Grid item xs={12} sm={12} md={12}>
                                        <label>English Language</label>
                                        <Col className="column" sm="12" md="12">
                                            <FormGroup>
                                                <div style={{ display: 'flex' }}>
                                                    <ReactQuill
                                                        placeholder="Privacy Policy (English)"
                                                        value={englishContent}
                                                        onChange={handleEnglishChange}
                                                        modules={modules}
                                                        formats={formats}
                                                        theme="snow"
                                                        style={{ height: '200px' }}
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Grid>
                                    {errors.english && <p style={{ color: 'red', paddingTop: '70px' }}>{errors.english}</p>}

                                    <Grid item xs={12} sm={12} md={12} style={{ marginTop: errors.english ? '30px' : '100px' }}>
                                        <label>Spanish Language</label>
                                        <Col className="column" sm="12" md="12">
                                            <FormGroup>
                                                <div style={{ display: 'flex' }}>
                                                    <ReactQuill
                                                        placeholder="Privacy Policy (Spanish)"
                                                        value={spanishContent}
                                                        onChange={handleSpanishChange}
                                                        modules={modules}
                                                        formats={formats}
                                                        theme="snow"
                                                        style={{ height: '200px' }}
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Grid>
                                    {errors.spanish && <p style={{ color: 'red', paddingTop: '70px' }}>{errors.spanish}</p>}

                                    <Grid item xs={12} sm={12} md={12} style={{ marginTop: errors.spanish ? '30px' : '100px' }}>
                                        <label>Armenian Language</label>
                                        <Col className="column" sm="12" md="12">
                                            <FormGroup>
                                                <div style={{ display: 'flex' }}>
                                                    <ReactQuill
                                                        placeholder="Privacy Policy (Armenian)"
                                                        value={armenianContent}
                                                        onChange={handleArmenianChange}
                                                        modules={modules}
                                                        formats={formats}
                                                        theme="snow"
                                                        style={{ height: '200px' }}
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Grid>
                                    {errors.armenian && <p style={{ color: 'red', paddingTop: '70px' }}>{errors.english}</p>}

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="updateBtn" style={{ marginTop: errors.armenian ? '30px' : '100px' }}>
                        <button type="submit">Update Content</button>
                    </div>
                </LocalForm>
            </div>
        </div>
    );

}

export default PrivacyPolicy;